import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, VideoEmbed } from '@guryou/html-components';
import { makeStyles } from '@material-ui/core';

import LocationModal from './LocationModal';
import WorkingHoursModal from './WorkingHoursModal';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#252525',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '1.2rem',
    paddingLeft: '10px',
  },
}));

const OnboardModals = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Modal id="setWorkingHours" maxWidth="md" title={t('ONBOARD.schedule')} showTitle={false} className={'padding-0'}>
        <WorkingHoursModal />
      </Modal>
      <Modal id="setLocation" maxWidth="md" title={'ONBOARD.location'} showTitle={false} className={'padding-0'}>
        <LocationModal />
      </Modal>
      <Modal id="embedModal" maxWidth="lg" title="" className={'padding-0'} titleClassName={classes.root}>
        <VideoEmbed />
      </Modal>
      {/* <Modal id="playVideo" maxWidth="md" title={'Video'} className={'padding-0'} titleClassName={classes.root}>
        <HtmlVideoPlayer />
      </Modal> */}
    </>
  );
};

export default OnboardModals;
